<template>
  <div class="row">
    <div class="col-sm-6">
      <div class="form-group">
        <label for="name">Navigation menu: </label>
        <div>
          <draggable v-model="nav_menus" class="list-group">
            <div class="list-group-item" v-for="(n, index) in nav_menus" :key="index">
              
              <div class="d-flex justify-content-between align-items-center" v-if="!edited_item[index]">
                <span>{{n.title}} <small class="text-grey nav-link-text" v-if="n.link">{{n.link}}</small></span>
                <span>
                  <span @click="setEditDisplay(index)"><i class="fa fa-edit text-info"></i></span>
                  <span @click="removeNav(nav_menus, index)"><i class="far fa-trash-alt text-danger" style="margin-left: 10px;"></i></span>
                  <span @click="addNewSubNav(index)"><i class="fa fa-plus text-success" style="margin-left: 10px;" v-if="!n.sub_nav"></i></span>
                </span>
              </div>
              <div class="row" v-if="edited_item[index]" v-on-clickaway="outside">
                <div class="col-sm-6">
                  <input class="form-control" v-model="n.title" type="text" placeholder="Title">
                </div>
                <div class="col-sm-6">
                  <input class="form-control" v-model="n.link" type="text" placeholder="URL">
                </div>
              </div>

              <div v-if="n.sub_nav" class="sub-nav">
                <div class="list-group-item" v-for="(sn, sn_index) in n.sub_nav" :key="sn.title">
                  <div class="d-flex justify-content-between align-items-center" v-if="!sub_edited_item[index+'_'+sn_index]">
                    <span>{{sn.title}} <small class="text-grey nav-link-text" v-if="sn.link">{{sn.link}}</small></span>
                    <span>
                      <span @click="setSubEditDisplay(index+'_'+sn_index)"><i class="fa fa-edit text-info"></i></span>
                      <span @click="removeNav(n.sub_nav, sn_index)"><i class="far fa-trash-alt text-danger" style="margin-left: 10px;"></i></span>
                    </span>
                    
                  </div>

                  <div class="row" v-if="sub_edited_item[index+'_'+sn_index]" v-on-clickaway="outside">
                    <div class="col-sm-6">
                      <input class="form-control" v-model="sn.title" type="text" placeholder="Title">
                    </div>
                    <div class="col-sm-6">
                      <input class="form-control" v-model="sn.link" type="text" placeholder="URL">
                    </div>
                  </div>
                </div>
                <div class="list-group-item text-success" @click="addSubNav(n.sub_nav, index+'_'+n.sub_nav.length)"><strong><i class="fa fa-plus"></i> เพิ่ม</strong></div>

              </div>
            </div>
            <div class="list-group-item text-success" @click="addNewNav"><strong><i class="fa fa-plus"></i> เพิ่ม</strong></div>
          </draggable>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { directive as onClickaway } from 'vue-clickaway';

export default {
  name: 'navOption',
  props: ['value'],
  components: { draggable },
  directives: { onClickaway: onClickaway },
  data() {
    return {
      nav_menus: this.value,
      edited_item: {},
      sub_edited_item: {},
    }
  },
  watch: {
    value(newValue) {
      this.nav_menus = newValue
    }
  },
  methods: {
    outside() {
      Object.keys(this.edited_item).forEach((key) => {
        this.edited_item[key] = false
      })
      Object.keys(this.sub_edited_item).forEach((key) => {
        this.sub_edited_item[key] = false
      })
      this.nav_menus.push({})
      this.nav_menus.pop()
    },
    addNewNav() {
      this.nav_menus.push({
        title: "",
        link: ""
      })
      this.setEditDisplay(this.nav_menus.length-1)
    },
    addSubNav(list, display_index) {
      list.push({
        title: "",
        link: ""
      })
      this.setSubEditDisplay(display_index)
    },
    addNewSubNav(index) {
      this.nav_menus[index].sub_nav = [{
        title: '',
        link: ''
      }]
      this.sub_edited_item[index+'_0'] = true
      this.nav_menus.push({})
      this.nav_menus.pop()
    },
    removeNav(list, index) {
      list.splice(index, 1)
      this.nav_menus.push({})
      this.nav_menus.pop()
    },
    setEditDisplay(index) {
      this.edited_item[index] = true
      this.nav_menus.push({})
      this.nav_menus.pop()
    },
    setSubEditDisplay(index) {
      this.sub_edited_item[index] = true
      this.nav_menus.push({})
      this.nav_menus.pop()
    }
  }
}
</script>

<style lang="scss">
.sub-nav {
  margin-top: 20px;
}
.nav-link-text {
  margin-left: 10px;
}
</style>
